import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faCheck } from "@fortawesome/free-solid-svg-icons";
import "./IntroTemplate.css";

const ScrollLink = ({ to, children, ...props }) => {
  const handleClick = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  return (
    <RouterLink to={to} onClick={handleClick} {...props}>
      {children}
    </RouterLink>
  );
};

function IntroTemplate({
  id = "page-introduction",
  title,
  description,
  image,
  eyebrow = "Axiomos Technologies",
  ctaLabel = "Ask us questions",
  ctaTo = "/contact",
}) {
  const backgroundStyle = image
    ? { "--intro-template-image": `url("${image}")` }
    : undefined;

  return (
    <section
      id={id}
      className="intro-template"
      style={backgroundStyle}
      aria-labelledby={`${id}-title`}
    >
      <div className="intro-template__texture" aria-hidden="true" />

      <div className="intro-template__container">
        <div className="intro-template__content">
          <p className="intro-template__eyebrow">
            <span aria-hidden="true" />
            {eyebrow}
          </p>

          <h1 id={`${id}-title`} className="intro-template__title">
            {title}
          </h1>

          <div className="intro-template__divider" aria-hidden="true">
            <span />
            <small>Built for what’s next</small>
          </div>

          <p className="intro-template__description">{description}</p>

          <div className="intro-template__actions">
            <ScrollLink className="intro-template__button" to={ctaTo}>
              {ctaLabel}
              <span aria-hidden="true">
                <FontAwesomeIcon icon={faArrowRight} />
              </span>
            </ScrollLink>

            <p className="intro-template__response-note">
              <span aria-hidden="true">
                <FontAwesomeIcon icon={faCheck} />
              </span>
              Response within one business day
            </p>
          </div>
        </div>

        <div className="intro-template__index" aria-hidden="true">
          <span>AX</span>
          <div />
          <small>Digital solutions</small>
        </div>
      </div>
    </section>
  );
}

export default IntroTemplate;
